import logo from "@/assets/kk-logo.webp";
import { WhatsAppIcon } from "./WhatsAppIcon";

const Icon = ({ d, size = 16 }: { d: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
    <path d={d} />
  </svg>
);

export function Footer() {
  return (
    <footer className="kk-footer">
      <div className="kk-footer__grid">
        <div>
          <img src={logo} alt="Kawamura Cirurgia Plástica" className="kk-footer__logo" width={160} height={110} loading="lazy" decoding="async" />
          <p style={{ margin: 0, color: "var(--kk-offwhite)", fontSize: 18 }}>Dr. Kelson Kawamura</p>
          <p style={{ margin: "4px 0 0" }}>Cirurgia Plástica</p>
          <p style={{ margin: "12px 0 0", fontSize: 13 }}>CRM 32174 · RQE 24787</p>
        </div>

        <div>

          <h2 className="kk-footer__title">Consultório</h2>
          <ul>
            <li className="kk-footer__item">
              <Icon d="M12 22s-7-7.58-7-12a7 7 0 1 1 14 0c0 4.42-7 12-7 12Z M12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
              <span>
                Rua Marechal Floriano Peixoto, 960<br />
                Edifício Torre Marechal, Sala 86<br />
                Foz do Iguaçu — PR · 85851-020
              </span>
            </li>
            <li className="kk-footer__item">
              <Icon d="M12 8v4l3 2 M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Z" />
              <span>Seg a Sex · 08h às 12h e 14h às 18h<br />Sáb · 08h às 12h</span>
            </li>
          </ul>
        </div>

        <div>
          <h2 className="kk-footer__title">Contato</h2>
          <ul>
            <li className="kk-footer__item">
              <span style={{ color: "var(--kk-champagne)", display: "inline-flex" }}><WhatsAppIcon size={16} /></span>
              <a href="https://wa.me/5545999175813" target="_blank" rel="noopener noreferrer">+55 45 99917-5813</a>
            </li>
            <li className="kk-footer__item">
              <Icon d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92Z" />
              <a href="tel:+5545999175813">+55 45 99917-5813</a>
            </li>
            <li className="kk-footer__item">
              <Icon d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2Z M22 6 12 13 2 6" />
              <a href="mailto:drkelsonkawamura@gmail.com">drkelsonkawamura@gmail.com</a>
            </li>
            <li className="kk-footer__item">
              <Icon d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Z M16 11.4a4 4 0 1 1-7.9 1.2A4 4 0 0 1 16 11.4Z M17.5 6.5h.01" />
              <a href="https://instagram.com/drkelsonkawamura" target="_blank" rel="noopener noreferrer">@drkelsonkawamura</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="kk-footer__bottom">
        <div>
          © {new Date().getFullYear()} Kawamura Cirurgia Plastica LTDA — CNPJ 37.941.107/0001-44 · Dr. Kelson Kawamura — Cirurgia Plástica · Membro SBCP
        </div>
        <div style={{ marginTop: 8, fontSize: 12, opacity: 0.85 }}>
          Responsável técnico: Dr. Kelson Kawamura · CRM/PR 32174 · RQE 24787. Conteúdo informativo,
          em conformidade com a Resolução CFM nº 1.974/2011 — não substitui avaliação presencial.
        </div>
        <div className="kk-footer__legal">
          <a href="/politica-de-privacidade" style={{ color: "var(--kk-champagne)" }}>
            Política de Privacidade
          </a>
          <span>
            Site desenvolvido por{" "}
            <a href="https://imedicina.com.br" target="_blank" rel="noopener noreferrer" className="kk-footer__credit-link">
              iMedicina
            </a>
          </span>
        </div>

      </div>
    </footer>
  );
}
